import {registerBackLayer} from '../../navigation/nativeBack';
import React,{useEffect,useRef,useId} from 'react';
import {createPortal} from 'react-dom';
import {X} from 'lucide-react';

let openSheets=0;let initialOverflow='';
export default function Sheet({title,children,onClose,busy=false,placement='bottom'}:{title:string;children:React.ReactNode;onClose:()=>void;busy?:boolean;placement?:'bottom'|'top'}) {
 const panel=useRef<HTMLDivElement>(null);const id=useId();const close=useRef(onClose);close.current=onClose;const saving=useRef(busy);saving.current=busy;
 useEffect(()=>{
  const top=()=>Array.from(document.querySelectorAll('.money-sheet[role=dialog]')).pop()===panel.current;
  const removeBack=registerBackLayer(()=>{if(!saving.current)close.current();},top);
  const previous=document.activeElement as HTMLElement|null;if(openSheets++===0)initialOverflow=document.body.style.overflow;
  document.body.style.overflow='hidden';panel.current?.focus();
  const viewport=window.visualViewport;
  const resize=()=>{
   const backdrop=panel.current?.parentElement;
   if(backdrop&&viewport){backdrop.style.height=`${viewport.height}px`;backdrop.style.top=`${viewport.offsetTop}px`;if(panel.current)panel.current.style.maxHeight=`${Math.max(120,viewport.height-20)}px`;}
  };
  resize();viewport?.addEventListener('resize',resize);viewport?.addEventListener('scroll',resize);
  const key=(e:KeyboardEvent)=>{
   if(!top())return;
   if(e.key==='Escape'&&!saving.current){e.preventDefault();close.current();}
   if(e.key==='Tab'){
    const nodes=Array.from(panel.current?.querySelectorAll<HTMLElement>('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),summary,[tabindex="0"]')||[]).filter(n=>!n.closest('details:not([open])')||n.tagName==='SUMMARY');
    const first=nodes[0],last=nodes[nodes.length-1];
    if(!first){e.preventDefault();return;}
    if(e.shiftKey&&(document.activeElement===first||document.activeElement===panel.current)){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===panel.current)){e.preventDefault();first.focus();}
   }
  };
  document.addEventListener('keydown',key);
  return()=>{removeBack();document.removeEventListener('keydown',key);viewport?.removeEventListener('resize',resize);viewport?.removeEventListener('scroll',resize);if(--openSheets===0)document.body.style.overflow=initialOverflow;if(previous?.isConnected)previous.focus();};
 },[]);
 return createPortal(<div className={`money-sheet-backdrop${placement==='top'?' money-sheet-near-top':''}`} onClick={e=>{if(e.target===e.currentTarget&&!busy)onClose();}}><div className="money-sheet money-surface" role="dialog" aria-modal="true" aria-labelledby={id} tabIndex={-1} ref={panel}>
  <header className="money-sheet-header"><h2 id={id}>{title}</h2><button className="money-icon-button" aria-label="Close" disabled={busy} onClick={onClose}><X size={22}/></button></header>
  <div className="money-sheet-body">{children}</div>
 </div></div>,document.body);
}
